<template>
  <div style="height: 100%">
    <v-container fluid v-if="loading" style="height: 100%">
      <v-layout align-center justify-center row fill-height class="text-xs-center" style="height: 100%">
        <v-progress-circular :size="50" indeterminate class="ma-5"></v-progress-circular>
      </v-layout>
    </v-container>

    <v-container fluid grid-list-xl>
      <v-layout row>
        <v-flex>
          <v-layout row wrap>
            <v-flex>
              <h1 class="main-title mb-3">Getting started with your first loyalty campaign</h1>
              <v-card>
                <div class="tabs-s1">
                  <v-tabs v-model="statTabs" color="grey" light icons-and-text>
                    <v-tab :href="'#points'">
                      <div class="tabs__item__title">Points</div>
                      <div class="tabs__item__count"><v-icon size="16" class="tab-icon"></v-icon></div>
                      <div class="tabs__item__conversion-rate"><v-icon size="14" >arrow_downward</v-icon></div>
                      <div class="tabs__item__sub-title"></div>
                    </v-tab>
                    <v-tab :href="'#history'">
                      <div class="tabs__item__title">History</div>
                      <div class="tabs__item__count"><v-icon size="16" class="tab-icon"></v-icon></div>
                      <div class="tabs__item__conversion-rate"><v-icon size="14">arrow_downward</v-icon></div>
                      <div class="tabs__item__sub-title"></div>
                    </v-tab>
                    <v-tab :href="'#profile'">
                      <div class="tabs__item__title">Profile</div>
                      <div class="tabs__item__count"><v-icon size="16" class="tab-icon"></v-icon></div>
                      <div class="tabs__item__conversion-rate"><v-icon size="14">arrow_downward</v-icon></div>
                      <div class="tabs__item__sub-title"></div>
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="statTabs">
                    <v-tab-item :value="'points'">
                      <v-card flat>
                        <v-card-text :style="{'height': (chartOptions.height + 32) + 'px'}">
                          <div class="clear">
                            <div class="ft"><span class="fwb">Available Points:</span><span>{{pointsData.points_earned - pointsData.points_redeem}}</span></div>
                            <div class="ft"><span class="fwb">Balance Points:</span><span>{{pointsData.points_balance}}</span></div>
                            <div class="ft"><span class="fwb">Redeemed Points:</span><span>{{pointsData.points_redeem}}</span></div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item :value="'history'">
                      <v-card flat>
                        <v-card-text>
                          <div class="test-data history-profile">
                            <h2>HISTORIC INFO</h2>
                            <table>
                              <thead>
                              <tr>
                                <th>Time & Date</th>
                                <th>Location</th>
                                <th>Staff Member</th>
                                <th>Description</th>
                                <th>Transaction Value</th>
                                <th>Receipt/Order Ref</th>
                                <th>Reason (if cancellation)</th>
                                <th>Points</th>
                                <th>Balance</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(item, index) in historyData" :key="index">
                                <td>{{item.created_at}}</td>
                                <td>{{item.location && item.location.city_text ? item.location.city_text : item.location }}</td>
                                <td>{{pointsData.staff_creator ? pointsData.staff_creator.name : '' }} </td>
                                <td>{{item.event && item.event.name ? item.event.name : item.event }}</td>
                                <td>{{item.shopping_value}}</td>
                                <td>{{item.transaction_number}}</td>
                                <td>{{item.reason_deleted}}</td>
                                <td>
                                  <span  v-if="!isBalance(item.program) || item.is_redeem || item.event.category === 'signup' || item.force_point">{{item.points}}</span>
                                  <span  v-if="isBalance(item.program) && item.event.category !== 'signup' && !item.is_redeem && !item.force_point">-</span>
                                </td>
                                <td>
                                  <span  v-if="!isBalance(item.program) || item.is_redeem || item.event.category === 'signup' || item.force_point">-</span>
                                  <span v-if="isBalance(item.program) && !item.is_redeem && item.event.category !== 'signup' && !item.force_point">{{item.points}}</span>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item :value="'profile'">
                      <v-card flat>
                        <v-card-text>
                          <h2>PROFILE INFO</h2>
                          <div>
                            <div>
                              <div><span class="fwb">Name:</span><span>{{profileData.name}}</span></div>
                            </div>
                            <div>
                              <div><span class="fwb">Tel:</span><span>{{profileData.phone}}</span></div>
                              <div><span class="fwb">DOB:</span><span>{{profileData.date_of_birth}}</span></div>
                            </div>
                          </div>
                          <div>
                            <div>
                              <div><span class="fwb">Client No:</span><span>{{profileData.number}}</span></div>
                              <div><span class="fwb">Joined at:</span><span>{{profileData.created_at}}</span></div>
                            </div>
                            <div>
                              <div><span class="fwb">Email:</span><span>{{profileData.email}}</span></div>
                              <div><span class="fwb">Nationality:</span><span>{{profileData.nationality}}</span></div>
                            </div>
                          </div>
                          <div>
                            <div>
                              <div><span class="fwb">City:</span><span>{{profileData.locations && profileData.locations[0] ? profileData.locations[0].city_text : profileData.location}}</span></div>
                              <div><span class="fwb">Country:</span><span>{{profileData.locations && profileData.locations[0]? profileData.locations[0].country_text : profileData.location }}</span></div>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>

                  </v-tabs-items>

                </div>
              </v-card>
            </v-flex>

          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new'
    },
    mounted () {
      let locale = Intl.DateTimeFormat().resolvedOptions().locale || 'en'
      locale = (this.$auth.check()) ? this.$auth.user().locale : locale
      this.locale = locale
      moment.locale(this.locale.substr(0,2))
    },
    data () {
      return {
        locale: 'en',
        loading: false,
        stats: null,
        statTabs: 'points',
        pointsData: [],
        historyData: [],
        profileData: [],
        chartOptions: {
          width: '100%',
          height: 342,
          chartArea: {
            left: 50, top: 20, bottom: 30, width:'100%'
          },
          hAxis: {
            format: 'MMM d',
            gridlines: {color: '#ebebeb', count: 7}
          }
        },
        chartPeriods: ['Last 7 days','Last 28 days', 'Last 90 days']
      }
    },
    created () {
      axios.post('/app/customerbyuser', {id: this.$auth.user().id}).then(response => {
        if (response && response.data && response.data.id) {
          // TODO: get the customer id
          axios.get('/app/customer' + response.data.id).then(response => {
            this.pointsData = response.data;
            this.historyData = response.data.history;
            this.profileData = response.data.customer;
          });
        }
      });
    },
    methods: {
      formatNumber(number) {
        return new Intl.NumberFormat(this.locale.replace('_', '-')).format(number)
      },
      isBalance(program) {
        if (program && program.points_expired_months && program.points_valid_date) {
          const day_expired = (moment().add(program.points_expired_months, 'M'));
          const day_valid = (moment().add(program.points_valid_date, 'd'));
          return !moment().isAfter(day_expired) && !moment().isAfter(day_valid);
        }
        return false;
      }
    },
    computed: {
      app () {
        return this.$store.getters.app
      }
    }
  }
</script>
<style>
</style>